"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpChannelCodeTypeMap = exports.EOtpChannelCodeType = void 0;
const OtpChannelTypes_enum_1 = require("./OtpChannelTypes.enum");
/**
  * Тип канала (кодовый или безкодовый)
  * Относится только к первому запросу в канал т.к. тип может измениться во время запроса
  */
var EOtpChannelCodeType;
(function (EOtpChannelCodeType) {
    EOtpChannelCodeType["code"] = "code";
    EOtpChannelCodeType["codeless"] = "codeless";
})(EOtpChannelCodeType || (exports.EOtpChannelCodeType = EOtpChannelCodeType = {}));
exports.OtpChannelCodeTypeMap = {
    [OtpChannelTypes_enum_1.EOtpChannelTypes.sms]: EOtpChannelCodeType.code,
    [OtpChannelTypes_enum_1.EOtpChannelTypes.mobileid_mts_push]: EOtpChannelCodeType.codeless,
    [OtpChannelTypes_enum_1.EOtpChannelTypes.mobileid_mts_push_sms]: EOtpChannelCodeType.codeless,
    [OtpChannelTypes_enum_1.EOtpChannelTypes.viber]: EOtpChannelCodeType.code,
    [OtpChannelTypes_enum_1.EOtpChannelTypes.voice]: EOtpChannelCodeType.code,
    [OtpChannelTypes_enum_1.EOtpChannelTypes.vk]: EOtpChannelCodeType.code,
    [OtpChannelTypes_enum_1.EOtpChannelTypes.whatsapp]: EOtpChannelCodeType.code,
    [OtpChannelTypes_enum_1.EOtpChannelTypes.flashcall]: EOtpChannelCodeType.code
};
//# sourceMappingURL=OtpChannelCodeType.enum.js.map